<template>
<div>
    <v-row justify="end" class="mb-4">
        <v-col cols="12" md="3">
            <v-menu
                v-model="menuDate"
                :close-on-content-click="false"
                max-width="290"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    :value="computedDateFormattedMomentjs"
                    label="Periodo"
                    dense
                    readonly
                    v-bind="attrs"
                    outlined
                    v-on="on"
                    @click:clear="date = null"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateRange"
                    @change="()=>{menuDate = false;fetch()}"
                    range
                ></v-date-picker>
                </v-menu>
        </v-col>
    </v-row>
    <v-row v-if="loading">
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader
            height="170"
            type="card"
            ></v-skeleton-loader>
        </v-col>
    </v-row> 
     
    <v-row v-else>
        <Can I="read" a="SalesNote">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_quoted">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper blue-bg">
                                <v-icon color="white" size="20">mdi-currency-usd</v-icon>
                            </div>
                            <div class="metric-title">Cotizado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_quoted | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        <Can I="read" a="SalesNote">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_confirmed">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper orange-bg">
                                <v-icon color="white" size="20">mdi-check-circle</v-icon>
                            </div>
                            <div class="metric-title">Confirmado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_confirmed | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        <Can I="read" a="SalesNote">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_confirmed_finished">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper purple-bg">
                                <v-icon color="white" size="20">mdi-flag-checkered</v-icon>
                            </div>
                            <div class="metric-title">Finalizado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_confirmed_finished | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        <Can I="read" a="SalesNote">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_confirmed_finished_not_invoiced">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper gray-bg">
                                <v-icon color="white" size="20">mdi-file-document</v-icon>
                            </div>
                            <div class="metric-title">Finalizado Sin DTE</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_confirmed_finished_not_invoiced | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        <Can I="read" a="SalesNote">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_invoiced">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper teal-bg">
                                <v-icon color="white" size="20">mdi-receipt</v-icon>
                            </div>
                            <div class="metric-title">Facturado Neto</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_invoiced | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>

        <Can I="read" a="Invoice">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_paid">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper orange-bg">
                                <v-icon color="white" size="20">mdi-cash-multiple</v-icon>
                            </div>
                            <div class="metric-title">Recaudado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_payments | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        
        <Can I="read" a="PurchaseInvoice">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_purchase_subtotal">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper red-bg">
                                <v-icon color="white" size="20">mdi-cart</v-icon>
                            </div>
                            <div class="metric-title">Compras Neto</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_purchase_subtotal | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        
        <Can I="read" a="PurchaseInvoice">
            <v-col cols="12" sm="6" md="4" lg="3" v-show="this.parameters.dashboard_card_purchase_paid">
                <v-card class="metric-card" height="120" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper purple-bg">
                                <v-icon color="white" size="20">mdi-credit-card</v-icon>
                            </div>
                            <div class="metric-title">Compras Pagado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_purchase_payments | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </Can>
        
        
    </v-row>
    <day-graph-complete :dateRange='dateRange' :customers='customers' :sellers='sellers' :loading='loading'/>
    
</div>
</template>

<script>
import {fetchDayGraph} from '@/api/salesNotes'
import DayGraphComplete from '@/components/sales/DayGraphComplete'
const moment = require('moment')
export default {
    name: 'CommercialGraph',
    components: {
        DayGraphComplete
    },
    data(){
        return {
            optionSelected:{},
            dateRange:[moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('yyyy-MM-DD'), moment().format('YYYY-MM-DD')],
            menuDate:false,
            dataRange:[
                {
                text:  moment(new Date().toString()).format('MMMM-YYYY'),
                after: moment(new Date().toString()).format('YYYY')+'-'+moment(new Date().toString()).format('MM')+'-01',
                before:moment(new Date().toString()).format('YYYY-MM-DD'),
                format:'DD-MM-YYYY',
                monthly:''
                },
                {
                    text:'30 días',
                    after: moment(new Date().toString()).add(-1,'month').format('YYYY-MM-DD'),
                    before:moment(new Date().toString()).format('YYYY-MM-DD'),
                    format:'DD-MM-YYYY',
                    monthly:''
                },
                {
                    text:'12 Meses',
                    after:moment(new Date().toString()).add(-1,'year').format('YYYY-MM-DD'),
                    before:moment(new Date().toString()).format('YYYY-MM-DD'),
                    format:'MMM',
                    monthly:true
                }
            ],
            quoted:[],
            confirmed:[],
            confirmed_finished:[],
            invoices:[],
            payments:[],
            customers:[],
            sellers:[],
            total_quoted:0,
            total_confirmed:0,
            total_confirmed_finished:0,
            total_confirmed_finished_not_invoiced:0,
            total_invoiced:0,
            total_payments:0,
            total_purchase_subtotal:0,
            total_purchase_payments:0,
            loading:false,  
        }
    },
    computed: {
      computedDateFormattedMomentjs () {
        return `${this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[0]?this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[0]:''} - ${this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[1]?this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[1]:''}`
      },
      parameters(){
        return this.$store.getters.getCompany
      }
    },
    methods:{
        async fetch(){
            this.loading=true
            //Trayendo el las Sales Notes para saber lo cotizado
            //sort = '', search = '', created_after = '', created_before = '', customer = '', seller = '', has_work_order = '', page = '', page_size = '' 
            var filterSeller=''
            if (!this.$can('realAll', 'SalesNote')){
                const user = this.$store.getters.getUser
                filterSeller=user.id
            }

            //tomando en cuenta fecha UTC porque la busqueda es en timestamp
        var created_before = ''
        var created_after = ''
        var emited_before = ''
        var emited_after = ''
        if(this.dateRange[0]) {
            created_after = moment(this.dateRange[0]).utc().format('yyyy-MM-DD HH:mm')
            emited_after = moment(this.dateRange[0]).format('yyyy-MM-DD')
        }
        if(this.dateRange[1]){
         created_before=moment(this.dateRange[1]).utc().add(1439,'minutes').format('yyyy-MM-DD HH:mm')
         emited_before=moment(this.dateRange[1]).format('yyyy-MM-DD')
        }


            const query=`created_after=${created_after}&created_before=${created_before}&emited_after=${emited_after}&emited_before=${emited_before}&customer__seller=${filterSeller}&monthly=${this.optionSelected.monthly}`

            await fetchDayGraph(query)
            .then((data)=>{
                this.loading=false
                const {quoted,confirmed,confirmed_finished,confirmed_finished_not_invoiced ,invoices, payments, total_quoted,total_confirmed,total_confirmed_finished ,total_confirmed_finished_not_invoiced,total_invoiced, total_payments,total_purchase_subtotal,total_purchase_payments,customers,sellers}=data
                this.quoted=quoted
                this.confirmed=confirmed
                this.confirmed_finished=confirmed_finished
                this.cofirmed_finished_not_invoiced=confirmed_finished_not_invoiced
                this.invoices=invoices
                this.payments=payments
                this.total_quoted=total_quoted
                this.total_confirmed=total_confirmed
                this.total_confirmed_finished=total_confirmed_finished
                this.total_confirmed_finished_not_invoiced=total_confirmed_finished_not_invoiced
                this.total_invoiced=total_invoiced
                this.total_payments=total_payments
                this.total_purchase_subtotal=total_purchase_subtotal
                this.total_purchase_payments=total_purchase_payments
                this.customers=customers
                this.sellers=sellers
            })
        }
    },
    async mounted(){
    this.optionSelected = this.dataRange[0]
    this.fetch()
    },
     watch:{
    //Revisa cambios en options para solicitar data nuevamente
    optionSelected:{
      deep: true,
      handler: 'fetch'
    }
  }
}
</script>

<style scoped>
/* Estilos de las tarjetas métricas - Google Analytics 4 style */
.metric-card {
  border-radius: 8px;
  border: 1px solid #e8eaed;
  transition: all 0.2s ease;
  cursor: pointer;
  background: white;
}

.metric-card:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border-color: #dadce0;
}

.metric-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.metric-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.metric-title {
  color: #5f6368;
  font-size: 0.875rem;
  font-weight: 500;
  flex: 1;
}

.metric-body {
  display: flex;
  flex-direction: column;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 500;
  color: #202124;
  margin-bottom: 4px;
  line-height: 1.2;
}

.metric-label {
  font-size: 0.75rem;
  color: #5f6368;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Colores de iconos - Google Analytics 4 style */
.blue-bg {
  background: #4285f4;
}

.orange-bg {
  background: #ff9800;
}

.purple-bg {
  background: #9c27b0;
}

.gray-bg {
  background: #757575;
}

.teal-bg {
  background: #009688;
}

.red-bg {
  background: #f44336;
}

/* Responsive - Google Analytics 4 style */
@media (max-width: 960px) {
  .metric-card {
    height: 110px !important;
  }
  
  .metric-value {
    font-size: 1.25rem;
  }
}

@media (max-width: 600px) {
  .metric-card {
    height: 100px !important;
  }
  
  .metric-header {
    margin-bottom: 8px;
  }
  
  .metric-icon-wrapper {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }
  
  .metric-title {
    font-size: 0.8rem;
  }
  
  .metric-value {
    font-size: 1.125rem;
  }
  
  .metric-label {
    font-size: 0.7rem;
  }
}
</style>